<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div
        class="card-head box-shadow bg-white d-md-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
      >

        <form class="search-box position-relative" @submit.prevent="rechercher">
          
          <input
            type="text"
            v-model="searchTerm"
            @keyup="rechercher"
            class="form-control shadow-none text-black rounded-0 border-0"
            placeholder="Rechercher un produit"
          />
          <button
            type="submit"
            class="bg-transparent text-primary transition p-0 border-0"
          >
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>

        <div class="d-sm-flex align-items-center">
          <a
            class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
            href="#"
            data-bs-toggle="modal"
            data-bs-target="#AddElementModal"
          >
            <i class="flaticon-plus position-relative ms-5 fs-12"></i>
            Ajouter un produit
        </a>
          
          <button
            class="default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mt-10 mt-md-0"
            type="button"
          >
            Export
            <i class="flaticon-file-1 position-relative ms-5 top-2 fs-15"></i>
          </button>
        </div>
      </div>
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="table-responsive">
          <table class="table text-nowrap align-middle mb-0">
            <thead>
              <tr>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                >
                  #
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                >
                  code
                </th>
                
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  categorie
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  libelle
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 wd-2"
                >
                  groupe de taxe
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 wd-2"
                >
                  Stock
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(pro, index) in elements" :key="index">
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  {{ pro.id }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  {{ pro.code }}
                </td>
                
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  {{ (pro.categorie) ? pro.categorie.libelle : "" }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  {{ pro.libelle }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  {{ (pro.groupeTaxe) ? pro.groupeTaxe.libelle : "" }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  <span v-for="(conditionnement, indexx) in pro.produitConditionnements" :key="indexx" class="badge bg-success me-2">
                    {{ conditionnement.conditionnement.libelle }} {{ conditionnement.prix }}
                  </span>
                </td>
                <td
                class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0"
              >
              <div class="dropdown">
                  <span class="badge text-white bg-primary fs-15 dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                      Actions
                      <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                  </span>
                  <ul class="dropdown-menu">
                    <li>
                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#MyModal"
                        @click="detail(pro.id)"
                      >
                        <i
                          class="flaticon-pen lh-1 me-8 position-relative top-1"
                        ></i>
                        Détail
                      </a>
                    </li>      
                    <li>
                      <!-- <a
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#AddElementModal"
                        @click="modification(pro)"
                      >
                        <i
                          class="flaticon-pen lh-1 me-8 position-relative top-1"
                        ></i>
                        Modifier
                      </a> -->
                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);"
                        @click="modification(pro)"
                      >
                        <i
                          class="flaticon-pen lh-1 me-8 position-relative top-1"
                        ></i>
                        Modifier
                      </a>
                    </li>
                    <li>
                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);" @click="suppression(pro.id,elements,'produit','ce produit')"
                      >
                        <i
                          class="flaticon-delete lh-1 me-8 position-relative top-1" 
                        ></i>
                        Supprimer
                      </a>
                    </li>
                  </ul>
              </div>
              </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
          <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
        </div>
      </div>
    </div>

    <!-- DETAILS -->
    <div class="modal fade createNewModal" id="MyModal" tabindex="-1"  aria-hidden="true" >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content p-15 p-md-40">
          <div class="modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25">
            <h5 class="modal-title fw-bold text-black">Détails</h5>
          </div>
          <div class="modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25">
          <div class="table-responsive">
          <table class="table text-nowrap align-middle mb-0">
            <!-- <thead>
              <tr>
                <th scope="col"  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                  #
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  >
                  Date
                </th>
                <th scope="col" 
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                  client
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                 Montant
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                 Reste A payer
                </th>
              </tr>
            </thead> -->
            <tbody v-if="element">
              <tr>
                <th> CODE </th>
                <td> {{  (element.code) ? element.code : "" }} </td>
                <th> LIBELLE </th>
                <td> {{ (element.libelle) ? element.libelle : "" }} </td>
              </tr>
              <tr>
                <th> CATEGORIE </th>
                <td> {{ (element.categorie) ? element.categorie.libelle : "" }} </td>
                <th> GOUPE DE TAXE </th>
                <td> {{ (element.groupeTaxe) ? element.groupeTaxe.libelle :"" }} </td>
              </tr>
              <!-- <tr v-for="(re, index) in reglements" :key="index">
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  {{ re.id }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  {{ format_date(re.dateReglement) }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                 {{  re.vente.client.nom+" "+re.vente.client.prenoms }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                 {{ re.montant }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                 {{ re.restAPayer }}
                </td>
              </tr>
              <tr>
                <td rowspan="4" class="shadow-none lh-1 fw-medium text-paragraph">
                  Total
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                 {{ total }}
                </td>
              </tr> -->
            </tbody>
          </table>
        </div>
          </div>
          <button
            type="button"
            class="btn-close shadow-none"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
      </div>
    </div>

    <AddProduitModal :item="selectedItem"   @close="recharger"/>
  </template>
  
<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue';
import { paginationFields } from '../Utilities/paginationFields';
import { error, suppression } from '../../utils/utils';
import ApiService from "../../services/ApiService";
import  { Produit }  from '../../models/Produit';
import AddProduitModal from './AddProduitModal.vue';
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import router from '@/router';
import { useRoute, useRouter } from 'vue-router';

  export default defineComponent({
    name: "ListeProduit",
    components: {
      AddProduitModal,
      PaginationComponent
    },
    setup: () => {

      const elements = ref<Array<Produit>>([])
      const selectedItem = ref(0);
      const element = ref<Produit>();
      const router = useRouter();
     
      function modification(item) {
        element.value = item;
        selectedItem.value = item.id;
        router.push({ name: 'EditProduit', params: { id: item.id } });
      }

      // BEGIN PAGINATE
        const searchTerm = ref('');
        const page = ref(1);
        const totalPages = ref(0);
        const limit = ref(10);
        const totalElements = ref(0);

        const handlePaginate = ({ page_, limit_ }) => {
          try {
            page.value = page_;
            getAll(page_, limit_);
          } catch (error) {
            //
          }
        };
        function rechercher(){
          getAll(page.value, limit.value, searchTerm.value );
        }
      // END PAGINATE

      const recharger = () => {
        getAll();
      };

      onMounted(() => {
        getAll();
      })

      function getAll(page = 1, limi = 10, searchTerm = '') {
        selectedItem.value = 0;
        return ApiService.get(`/produits?page=${page}&limit=${limi}&mot=${searchTerm}&`)
        .then(({ data }) => {
          console.log('result', data.data.data);
          elements.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
          console.log("yes",data.data.data);
        })
        .catch(({ response }) => {
          error(response.data)
        });
      } 

      function detail(id) {
        return ApiService.get(`produit/${id}`)
        .then(({ data }) => {
          console.log('produit', data.data, id);
          element.value = data.data;
        })
        .catch(({ response }) => {
          error(response.data)
        });
      }

      return { 
        getAll,
        suppression,
        modification,
        elements,
        element,
        recharger,
        selectedItem,
        detail,

        page,
        totalPages,
        totalElements,
        limit,
        searchTerm,
        handlePaginate,
        rechercher
      };
    }

  });
  
</script>